// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_gzKvU3fgavH7yKKN8GLx {
  margin-bottom: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/MessageWarning/style.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".wrapper {\n  margin-bottom: 2rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_gzKvU3fgavH7yKKN8GLx`
};
export default ___CSS_LOADER_EXPORT___;
